import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import { SITE_NAME } from '../config/site';

export default function ThankYouPage() {
  const { state } = useLocation();
  const plan = state?.selectedPlan;

  const title = `Thank you | ${SITE_NAME}`;
  const desc = 'Thanks for joining the Notrack waitlist. We will contact you with early access details.';

  return (
    <>
      <SeoMeta title={title} description={desc} path="/thank-you" ogType="website" noindex />

      <main className="section thank-you">
        <div className="thank-you__bg" aria-hidden />
        <div className="thank-you__shell">
          <div className="card thank-you__card">
            <p className="thank-you__eyebrow">
              <span className="thank-you__dot" aria-hidden /> Waitlist confirmed
            </p>
            <h1 className="thank-you__title">Thank you for your interest</h1>
            <p className="thank-you__sub">
              We’ll contact you and let you know how you can access the app.
            </p>
            {plan ? <p className="thank-you__meta">Selected: <strong>{plan}</strong></p> : null}

            <div className="thank-you__actions">
              <Link className="btn btn-primary" to="/">
                Back to home
              </Link>
              <Link className="btn btn-secondary" to="/blog">
                Read guides
              </Link>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

